<template>
    <div>
        <b-modal id="cost-unit-add-payment-modal" hide-footer no-close-on-backdrop size="xl" title="Zahlung hinzufügen"
            :visible="isModalOpen" @hide="hideReset()" @show="loadForm">
            <div class="record-cost-unit-edit-modal">
                <csp-desktop-info-card
                    ref="costUnitInfoCard"
                    :cols="12"
                    :form-context="formContext"
                    icon="inticon-users"
                    title="Zahlung"
                    @cancel-form="reset"
                    @save="savePaymentFormData">
                    <h2>Zahlung hinzufügen</h2>
                    <b-row>
                        <csp-desktop-info-card-element
                            class="col-5"
                            :form-context="formContext"
                            label="Art der Zahlung"
                            property="paymentType"
                            :required="true"
                            type="autocomplete"
                            @change="handlePaymentTypeChange"/>
                        <csp-desktop-info-card-element
                            class="col-2"
                            :form-context="formContext"
                            label="Bezahlt am"
                            property="datePaid"
                            :required="true"
                            type="datepicker"/>
                        <csp-desktop-info-card-element
                            class="col-2"
                            :form-context="formContext"
                            label="Betrag"
                            property="amount"
                            :required="true"
                            type="currency"/>
                        <csp-desktop-info-card-element
                            autocomplete="on"
                            class="col-3"
                            :form-context="formContext"
                            label="Bemerkung"
                            property="description"
                            type="text"/>
                    </b-row>
                </csp-desktop-info-card>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import Container from '@services/Container';
    import '@desktop/scss/components/record/document-upload-modal.scss';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';
    import CostUnitPaymentTypeEnum from '@js/enums/damage/CostUnitPaymentTypeEnum';

    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();

    export default {
        name: 'CostUnitAddPaymentModal',
        mixins: [FormDataMixin],
        props: {
            costUnitId: {
                type: Number,
                default: null,
            },
            isModalOpen: {
                type: Boolean,
                default: false,
            },
            recordId: {
                type: Number,
                required: true,
            },
        },
        emits: ['close', 'updated'],
        data() {
            return {
                lastPaymentTypeId: null,
            }
        },
        methods: {
            amountOpenCopayment() {
                return this.formContext.form.getProperty('amountOpenCopayment');
            },
            amountOpenVat() {
                return this.formContext.form.getProperty('amountOpenVat');
            },
            paymentType() {
                return this.formContext.form.getProperty('paymentType');
            },
            lastPaymentType() {
                return this.lastPaymentTypeId;
            },
            handlePaymentTypeChange() {
                const paymentType = this.paymentType();

                if (!this.formContext.form.getProperty('isEntityNew')) {
                    return; // no change if payment is not in new creation
                }

                switch (paymentType) {
                case CostUnitPaymentTypeEnum.COPAYMENT_COMPENSATION:
                case CostUnitPaymentTypeEnum.COPAYMENT_COMPENSATION_CAR_DEALER:
                    this.formContext.form.setProperty(
                        'amount',
                        this.amountOpenCopayment()
                    );
                    break;
                case CostUnitPaymentTypeEnum.VAT_COMPENSATION:
                    this.formContext.form.setProperty(
                        'amount',
                        this.amountOpenVat()
                    );
                    break;
                default: {
                    const lastPaymentType = this.lastPaymentType();
                    const presetPaymentTypes = [
                        CostUnitPaymentTypeEnum.COPAYMENT_COMPENSATION,
                        CostUnitPaymentTypeEnum.COPAYMENT_COMPENSATION_CAR_DEALER,
                        CostUnitPaymentTypeEnum.VAT_COMPENSATION,
                    ];

                    if (presetPaymentTypes.includes(lastPaymentType)) {
                        // reset amount to 0 if value was set by a preset payment type
                        this.formContext.form.setProperty('amount', 0);
                    }
                }
                }

                // set new type as last type for next change
                this.lastPaymentTypeId = paymentType;
            },
            loadForm() {
                const loadFunction = () => {
                    return recordRepository.loadCostUnitPaymentCreationForm(this.costUnitId, this.recordId);
                }
                this.loadFormData(loadFunction);
            },
            hideReset() {
                this.$refs.costUnitInfoCard.cancelFormData();
            },
            reset() {
                this.formContext.isLoaded = false;
                this.$emit('close');
            },
            savePaymentFormData(formContext) {
                const saveFunction = (objectId, postData) => {
                    return recordRepository.saveCostUnitPayment(this.costUnitId, this.recordId, postData);
                }
                this.saveFormData(formContext, saveFunction, false).then(() => {
                    this.$emit('updated');
                    this.reset();
                });
            },
        },
    }
</script>
